<!--<template>-->
<!--  <div-->
<!--    id="detail"-->
<!--    style="width: 1300px; margin: 0 auto"-->
<!--    v-loading.fullscreen.lock="fullscreenLoading"-->
<!--    element-loading-text="处理中…… 请耐心等待"-->
<!--    element-loading-spinner="el-icon-loading"-->
<!--  >-->
<!--    <div class="detailBox">-->
<!--    <div class="left-nav" >-->
<!--      <div class="titleNav">-->
<!--        <div id="nav-body">-->
<!--          <div class="bg_title">-->
<!--            <p style="color: #fff;font-size:24px;">{{ firstMenuName }}</p>-->
<!--            <p style="color: #fff;font-size:14px;">NEWS</p>-->
<!--          </div>-->
<!--          <div-->
<!--            :class="{ active: item.id == secondId, 'nav-every': true }"-->
<!--            v-for="(item, i) in menuList"-->
<!--            @click="toList(item.id)"-->
<!--            :key="i"-->
<!--            style="-->
<!--              text-align: left;-->
<!--              width: 200px;-->
<!--              white-space: nowrap;-->
<!--              overflow: hidden;-->
<!--              text-overflow: ellipsis;-->
<!--              display: flex;-->
<!--              align-items: center;-->
<!--              justify-content: space-between;-->
<!--            "-->
<!--            :title="item.label"-->
<!--          >-->
<!--            <p>{{ item.lable }}</p>-->
<!--            <p class="el-icon-d-arrow-right"></p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--&lt;!&ndash;    <div id="nav-header">&ndash;&gt;-->
<!--&lt;!&ndash;      {{ firstMenuName }} <span class="en-name">NEWS11</span>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--&lt;!&ndash;    <div id="detail-content">&ndash;&gt;-->
<!--&lt;!&ndash;      <div id="left-nav">&ndash;&gt;-->
<!--&lt;!&ndash;        <div id="nav-body">&ndash;&gt;-->
<!--&lt;!&ndash;          <div&ndash;&gt;-->
<!--&lt;!&ndash;            :class="{ active: item.id == secondId, 'nav-every': true }"&ndash;&gt;-->
<!--&lt;!&ndash;            v-for="(item, i) in menuList"&ndash;&gt;-->
<!--&lt;!&ndash;            @click="toList(item.id)"&ndash;&gt;-->
<!--&lt;!&ndash;            :key="i"&ndash;&gt;-->
<!--&lt;!&ndash;            style="&ndash;&gt;-->
<!--&lt;!&ndash;              text-align: left;&ndash;&gt;-->
<!--&lt;!&ndash;              width: 200px;&ndash;&gt;-->
<!--&lt;!&ndash;              white-space: nowrap;&ndash;&gt;-->
<!--&lt;!&ndash;              overflow: hidden;&ndash;&gt;-->
<!--&lt;!&ndash;              text-overflow: ellipsis;&ndash;&gt;-->
<!--&lt;!&ndash;            "&ndash;&gt;-->
<!--&lt;!&ndash;            :title="item.label"&ndash;&gt;-->
<!--&lt;!&ndash;          >&ndash;&gt;-->
<!--&lt;!&ndash;            {{ item.lable }}&ndash;&gt;-->
<!--&lt;!&ndash;          </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--      <div id="right-content" class="rightContent">-->
<!--        <div v-show="!showIframe && !showBadRecord" style="margin-top: 20px">-->
<!--          <div id="article-header">-->
<!--            {{ content.title }}-->
<!--          </div>-->
<!--          <div id="article-info">-->
<!--            <span class="info-text">来源:{{ content.source }} <el-divider direction="vertical"></el-divider>;</span>-->
<!--            <span class="info-text">作者:{{ content.author }} <el-divider direction="vertical"></el-divider></span>-->
<!--            <span class="info-text">时间:{{ content.addDate }} <el-divider direction="vertical"></el-divider></span>-->
<!--            <span class="info-text">点击:{{ content.hits }}</span>-->
<!--          </div>-->
<!--          <el-divider></el-divider>-->
<!--          <div id="article-content" class="content">-->
<!--            <div v-html="content.contentString" class="ql-editor"></div>-->
<!--          </div>-->
<!--          ​-->
<!--          <div-->
<!--            v-for="(item, index) in content.files"-->
<!--            :key="index"-->
<!--            style="width: 100%; text-align: center"-->
<!--          >-->
<!--            &lt;!&ndash; <iframe-->

<!--              :src="-->
<!--                '/mainsys/cmsapi/getFilePath?fileId=' + item.id + '&password='-->
<!--              "-->
<!--              width="500px"-->
<!--              height="280px"-->
<!--            ></iframe> &ndash;&gt;-->
<!--            <div-->
<!--              style="-->
<!--                display: flex;-->
<!--                flex-wrap: wrap;-->
<!--                justify-content: center;-->
<!--                width: 100%;-->
<!--              "-->
<!--              v-if="-->
<!--                item.fileSuffix == '.MP4' ||-->
<!--                item.fileSuffix == '.mp4' ||-->
<!--                item.fileSuffix == 'MP4' ||-->
<!--                item.fileSuffix == 'mp4'-->
<!--              "-->
<!--            >-->
<!--              <video width="480" height="400" controls>-->
<!--                <source-->
<!--                  :src="-->
<!--                    '/mainsys/cmsapi/getFilePath?fileId=' +-->
<!--                    item.id +-->
<!--                    '&password='-->
<!--                  "-->
<!--                  type="video/mp4"-->
<!--                />-->
<!--              </video>-->
<!--            </div>-->

<!--            <iframe-->
<!--              v-if="-->
<!--                item.fileSuffix == '.pdf' ||-->
<!--                item.fileSuffix == '.PDF' ||-->
<!--                item.fileSuffix == 'PDF' ||-->
<!--                item.fileSuffix == 'pdf'-->
<!--              "-->
<!--              :src="-->
<!--                '/mainsys/cmsapi/getFilePath?fileId=' + item.id + '&password='-->
<!--              "-->
<!--              width="90%"-->
<!--              height="600px"-->
<!--            ></iframe>-->
<!--            <a-->
<!--              href="#"-->
<!--              @click="downloadFile(item)"-->
<!--              style="display: block; width: 100%; margin: 12px 0 24px 0"-->
<!--              >{{ item.fileName }}</a-->
<!--            >-->
<!--          </div>-->

<!--          &lt;!&ndash; <div-->
<!--            style="margin: 10px 0 0 40px;"-->
<!--            v-if="content.files && content.files.length > 0"-->
<!--          >-->
<!--                     <span style="font-size:18px;font-weight:600;color:rgba(203,203,203,1);">附件下载</span>-->
<!--            <div v-for="(item, index) in content.files">-->
<!--              <a-->
<!--                :href="'/mainsys/cmsapi/getFilePath?fileId=' + item.id"-->
<!--                target="_blank"-->
<!--                >{{ item.fileName }}</a-->
<!--              >-->
<!--              <a href="#" @click="downloadFile(item)">{{ item.fileName }}</a>-->
<!--            </div>-->
<!--            <div-->
<!--              v-for="(item, index) in content.files"-->
<!--              v-if="item.fileSuffix != '.MP4' && item.fileSuffix != '.mp4'"-->
<!--            >-->
<!--              <a href="#" @click="downloadFile(item)">{{ item.fileName }}</a>-->
<!--            </div>-->
<!--          </div> &ndash;&gt;-->
<!--        </div>-->

<!--        <div v-show="showBadRecord">-->
<!--          &lt;!&ndash;显示不良记录&ndash;&gt;-->
<!--          <el-table-->
<!--            default-expand-all-->
<!--            stripe-->
<!--            :data="mainData"-->
<!--            border-->
<!--            style="width: 100%; margin-top: 30px"-->
<!--            :header-cell-style="{ color: '#0B52A3', textAlign: 'center' }"-->
<!--            :cell-style="{ color: '#000', textAlign: 'center' }"-->
<!--          >-->
<!--            <el-table-column prop="labItemName" width="150px" label="序号">-->
<!--              <template slot-scope="scope">-->
<!--                {{ scope.$index + 1 }}-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--              prop="userName"-->
<!--              width="150px"-->
<!--              label="姓名"-->
<!--            ></el-table-column>-->
<!--            <el-table-column-->
<!--              prop="time"-->
<!--              min-width="180"-->
<!--              label="时间"-->
<!--            ></el-table-column>-->
<!--            <el-table-column-->
<!--              prop="deviceName"-->
<!--              min-width="100px"-->
<!--              label="设备名称"-->
<!--            ></el-table-column>-->
<!--            <el-table-column-->
<!--              prop="detail"-->
<!--              min-width="150px"-->
<!--              label="种类"-->
<!--            ></el-table-column>-->
<!--            <el-table-column-->
<!--              prop="detailLevel"-->
<!--              min-width="150px"-->
<!--              label="严重程度"-->
<!--            ></el-table-column>-->
<!--            <el-table-column-->
<!--              prop="score"-->
<!--              min-width="150px"-->
<!--              label="扣除信用积分"-->
<!--            ></el-table-column>-->
<!--          </el-table>-->
<!--        </div>-->
<!--        <div v-show="showIframe">-->
<!--          <iframe-->
<!--            :src="url"-->
<!--            style="-->
<!--              width: 1100px;-->
<!--              min-height: 600px;-->
<!--              margin: 0px;-->
<!--              padding: 0px;-->
<!--              border: 0;-->
<!--              overflow-y: hidden;-->
<!--            "-->
<!--          ></iframe>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: "detail",-->
<!--  data() {-->
<!--    return {-->
<!--      mainData: [],-->
<!--      showBadRecord: false,-->
<!--      url: "",-->
<!--      showIframe: false,-->
<!--      contentId: this.$route.params.contentId,-->
<!--      contentIds: this.$route.params.contentIds,-->
<!--      fullscreenLoading: false,-->
<!--      content: {-->
<!--        files: [],-->
<!--      }, //内容-->
<!--      firstMenuName: "",-->
<!--      secondId: "",-->
<!--      menuList: [],-->
<!--    };-->
<!--  },-->
<!--  methods: {-->
<!--    // 获取不良积分数据-->
<!--    getTableList() {-->
<!--      var fd = new FormData();-->
<!--      fd.append("userId", sessionStorage.getItem("userId"));-->
<!--      fd.append("pageNum", 1);-->
<!--      fd.append("pageSize", 999);-->

<!--      this.fullscreenLoading = true;-->
<!--      axios-->
<!--        .post("creditSystem/selectFlow", fd, {-->
<!--          headers: {-->
<!--            "Content-Type": "application/x-www-form-urlencoded",-->
<!--          },-->
<!--        })-->
<!--        .then((response) => {-->
<!--          this.mainData = response.data.data;-->
<!--          this.fullscreenLoading = false;-->
<!--        })-->
<!--        .catch((error) => {-->
<!--          this.fullscreenLoading = false;-->
<!--          this.$message({-->
<!--            message: "数据请求失败，请重试。",-->
<!--            type: "error",-->
<!--          });-->
<!--        });-->
<!--    },-->
<!--    getContent() {-->
<!--      this.fullscreenLoading = true;-->
<!--      var fd = new FormData();-->
<!--      fd.append("contentId", this.contentId);-->
<!--      axios-->
<!--        .post("/cmsapi/contents", fd, {-->
<!--          headers: { "Content-Type": "application/x-www-form-urlencoded" },-->
<!--        })-->
<!--        .then((response) => {-->
<!--          var recData = response.data;-->
<!--          this.content = recData.content;-->
<!--          console.log(this.content.contentString,'content')-->
<!--          this.secondId = recData.secondId;-->
<!--          this.firstMenuName = recData.firstMenuName;-->
<!--          //如果只有一条，就把一级菜单放上。-->
<!--          if (recData.secondMenu.length == 0) {-->
<!--            this.menuList = [-->
<!--              {-->
<!--                lable: recData.firstMenuName,-->
<!--                id: recData.firstMenuId,-->
<!--              },-->
<!--            ];-->
<!--          } else {-->
<!--            this.menuList = recData.secondMenu;-->
<!--          }-->
<!--          // if (this.content.files && this.content.files.length > 0) {-->
<!--          //   this.content.files.forEach(item => {-->
<!--          //     if (item.fileSuffix == ".pdf" || item.fileSuffix == ".PDF") {-->
<!--          //       var fd = new FormData();-->
<!--          //       fd.append("fileId", item.id);-->
<!--          //       fd.append("password", "");-->
<!--          //       axios-->
<!--          //         .post("/cmsapi/getFilePath", fd, {-->
<!--          //           headers: {-->
<!--          //             "Content-Type": "application/x-www-form-urlencoded"-->
<!--          //           }-->
<!--          //         })-->
<!--          //         .then(res => {-->
<!--          //           let blob = new Blob([res.data], {-->
<!--          //             type: 'application/pdf'-->
<!--          //           });-->
<!--          //           let fileURL = URL.createObjectURL(blob);-->
<!--          //           item.src = fileURL;-->
<!--          //         });-->
<!--          //     }-->
<!--          //     console.log(item, "item");-->
<!--          //   });-->
<!--          // }-->
<!--          this.fullscreenLoading = false;-->
<!--        })-->
<!--        .catch((error) => {-->
<!--          this.fullscreenLoading = false;-->
<!--        });-->
<!--    },-->
<!--    toList: function (menuId) {-->
<!--      if(this.firstMenuName == '教学资源'){-->
<!--        this.$router.push({-->
<!--       path: "ListTeach:menuId",-->
<!--        name: "ListTeach",-->
<!--        params: { menuId: menuId },-->
<!--      });-->
<!--      }else{-->
<!--                this.$router.push({-->
<!--        path: "List:menuId",-->
<!--        name: "List",-->
<!--        params: { menuId: menuId },-->
<!--      });-->
<!--      }-->

<!--    },-->
<!--    downloadFile(fileItem) {-->
<!--      //下载文件-->
<!--      if (fileItem.password == "1") {-->
<!--        //有密码-->
<!--        this.$prompt("下载该附件需要密码", "提示", {-->
<!--          confirmButtonText: "确定",-->
<!--          cancelButtonText: "取消",-->
<!--        })-->
<!--          .then((value) => {-->
<!--            window.open(-->
<!--              "/mainsys/cmsapi/downloadFile?fileId=" +-->
<!--                fileItem.id +-->
<!--                "&password=" +-->
<!--                value.value-->
<!--            );-->
<!--          })-->
<!--          .catch(() => {-->
<!--            this.$message.info("取消下载");-->
<!--          });-->
<!--      } else {-->
<!--        // var fd = new FormData();-->
<!--        // fd.append("fileId", fileItem.id);-->
<!--        // fd.append("password",'');-->
<!--        // axios.post("/cmsapi/getFilePath", fd, {-->
<!--        //   headers: { "Content-Type": "application/x-www-form-urlencoded" }-->
<!--        // });-->
<!--        window.open(-->
<!--          "/mainsys/cmsapi/downloadFile?fileId=" + fileItem.id + "&password="-->
<!--        );-->
<!--      }-->
<!--    },-->
<!--  },-->
<!--  watch: {-->
<!--    $route(to, from) {-->
<!--      var that = this;-->
<!--    },-->
<!--  },-->
<!--  created() {-->
<!--    console.log(this.$route.params.label);-->
<!--    this.getContent();-->
<!--    if (this.$route.params.label == "仪器预约记录") {-->
<!--      this.url = this.targetUrl + "lems/synOrderIframeRecord";-->
<!--      this.showIframe = true;-->
<!--    } else if (this.$route.params.label == "使用记录") {-->
<!--      this.url = this.targetUrl + "lems/synUseIframeRecord/my";-->
<!--      this.showIframe = true;-->
<!--    } else if (this.$route.params.label == "实验室预约记录") {-->
<!--      this.url = this.targetUrl + "open/MyIframeAppointment";-->
<!--      this.showIframe = true;-->
<!--    } else if (this.$route.params.label == "考勤记录") {-->
<!--      this.url =-->
<!--        this.targetUrl + "mainsys/scheduling/QueryTimetableList.jsp?type=tea";-->
<!--      this.showIframe = true;-->
<!--    } else if (this.$route.params.label == "实验室信息") {-->
<!--      this.url = this.targetUrl + "LabOverview/getCenterIframePage/cms";-->
<!--      this.showIframe = true;-->
<!--    } else if (this.$route.params.label == "违规扣分处罚信息") {-->
<!--      this.getTableList();-->
<!--      this.showBadRecord = true;-->
<!--    } else if (this.$route.params.label == "成绩查询") {-->
<!--      var type = sessionStorage.getItem("schType");-->
<!--      if (type == "s") {-->
<!--        this.url =-->
<!--          this.targetUrl +-->
<!--          "mainsys/scheduling/score/NewGradeOfCourse.jsp?type=manager";-->
<!--      } else {-->
<!--        this.url =-->
<!--          this.targetUrl +-->
<!--          "mainsys/scheduling/score/NewGradeOfCourse.jsp?type=select";-->
<!--      }-->
<!--      this.showIframe = true;-->
<!--    } else {-->
<!--      this.showIframe = false;-->
<!--    }-->
<!--    // sessionStorage.setItem('schType',data.data.schType)-->
<!--  },-->
<!--};-->
<!--</script>-->
<!--<style scoped>-->
<!--.detailBox{-->
<!--  width: 1100px;-->
<!--  display: flex;-->
<!--  justify-content: space-between;-->
<!--  min-height: 600px;-->
<!--  .left-nav{-->
<!--    width: 19%;-->
<!--    position: relative;-->
<!--    height: 300px;-->
<!--    background-color: #f2f2f2;-->
<!--    .bg_title{-->
<!--      width: 209px;-->
<!--      height: 90px;-->
<!--      background: url("~@/assets/list/bg1.png") no-repeat;-->
<!--      background-size: 100% 100%;-->
<!--      padding: 15px 0 0 25px;-->
<!--    }-->
<!--  }-->
<!--  .rightContent{-->
<!--    width: 80%;-->
<!--  }-->
<!--}-->
<!--.content >>> img {-->
<!--  max-width: 100%;-->
<!--  margin: auto;-->
<!--  height: auto;-->
<!--}-->
<!--.ql-editor >>> .ql-video {-->
<!--  width: 700px !important;-->
<!--  height: 350px !important;-->
<!--}-->
<!--.titleNav{-->
<!--  position: absolute;-->
<!--  top: -10%;-->
<!--}-->
<!--</style>-->
<!--<template>-->
<!--  <div-->
<!--    id="list"-->
<!--    class="w1100"-->
<!--    v-loading.fullscreen.lock="fullscreenLoading"-->
<!--    element-loading-text="处理中…… 请耐心等待"-->
<!--    element-loading-spinner="el-icon-loading"-->
<!--  >-->
<!--    <div class="contentBox">-->
<!--          <div class="left-nav" >-->
<!--            <div class="titleNav">-->
<!--              <div id="nav-body">-->
<!--                <div class="bg_title">-->
<!--                  <p style="color: #fff;font-size:24px;">{{ firstMenuName }}</p>-->
<!--                  <p style="color: #fff;font-size:14px;">LIST</p>-->
<!--                </div>-->
<!--                <div-->
<!--                  :class="{ active: item.id == menuId, 'nav-every': true }"-->
<!--                  style="text-align: left;width:200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"-->
<!--                  v-for="(item, i) in menuList"-->
<!--                  @click="toList(item.id, item.label)"-->
<!--                  :key="i"-->
<!--                  :title="item.label"-->
<!--                >-->
<!--                  {{ item.label }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="rightContent">-->
<!--            <div class="box_card">-->
<!--              <p-->
<!--                v-show="linkAddress != ''"-->
<!--                style="margin-top: 10px;"-->
<!--              >-->
<!--                <a :href="linkAddress">链接地址</a>-->
<!--              </p>-->
<!--              <el-card v-for="(c,i) in contentList" :key="i" :class="i==activeIndex?'active_card':'card_data'" @click.native="toDetail(c,i)">-->
<!--                <div class="card_flex">-->
<!--                  <div class="left_box">-->
<!--                    <p style="height: 50px" class="title">{{c.title}}</p>-->
<!--                    <p class="titleTime">{{c.addDate.substr(0,11)}}</p>-->
<!--                  </div >-->
<!--                  <div class="right_box">-->
<!--                    <img :src="c.picUrl?'/mainsys/UserFiles/menupic/'+c.picUrl:defaultImg" alt="">-->
<!--                  </div>-->
<!--                </div>-->
<!--              </el-card>-->

<!--            </div>-->

<!--&lt;!&ndash;            <p&ndash;&gt;-->
<!--&lt;!&ndash;              v-show="linkAddress != ''"&ndash;&gt;-->
<!--&lt;!&ndash;              style="margin-top: 10px;"&ndash;&gt;-->
<!--&lt;!&ndash;            >&ndash;&gt;-->
<!--&lt;!&ndash;              <a :href="linkAddress">链接地址</a>&ndash;&gt;-->
<!--&lt;!&ndash;            </p>&ndash;&gt;-->
<!--&lt;!&ndash;            <div&ndash;&gt;-->
<!--&lt;!&ndash;              style="width:100%;min-height:400px;margin-left:40px;margin-top:24px"&ndash;&gt;-->
<!--&lt;!&ndash;            >&ndash;&gt;-->
<!--&lt;!&ndash;              <div&ndash;&gt;-->
<!--&lt;!&ndash;                v-for="(item, i) in contentList"&ndash;&gt;-->
<!--&lt;!&ndash;                @click="toDetail(item.id, item.title)"&ndash;&gt;-->
<!--&lt;!&ndash;                :key="i"&ndash;&gt;-->
<!--&lt;!&ndash;                style="height:100px;width:100%;border-bottom: 1px dashed #D9D9D9;font-size: 16px;&ndash;&gt;-->
<!--&lt;!&ndash;    color: #4D4D4D;margin-bottom:12px;cursor: pointer;"&ndash;&gt;-->
<!--&lt;!&ndash;              >&ndash;&gt;-->
<!--&lt;!&ndash;                <div&ndash;&gt;-->
<!--&lt;!&ndash;                  style="width:60%;height:100px;float:left;display:flex;align-items:center;flex-wrap:wrap"&ndash;&gt;-->
<!--&lt;!&ndash;                >&ndash;&gt;-->
<!--&lt;!&ndash;                  <div style="width:100%">&ndash;&gt;-->
<!--&lt;!&ndash;                    {{ item.title }}&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                  <div style="width:100%">&ndash;&gt;-->
<!--&lt;!&ndash;                    {{ item.addDate.substr(0, 11) }}&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                <div style="width:40%;height:100px;float:left;display:flex;align-items:center;">&ndash;&gt;-->
<!--&lt;!&ndash;                  <img&ndash;&gt;-->
<!--&lt;!&ndash;                    v-if="item.picUrl"&ndash;&gt;-->
<!--&lt;!&ndash;                    :src="&ndash;&gt;-->
<!--&lt;!&ndash;                  item.picUrl&ndash;&gt;-->
<!--&lt;!&ndash;                    ? '/mainsys/UserFiles/menupic/' + item.picUrl&ndash;&gt;-->
<!--&lt;!&ndash;                    : ''&ndash;&gt;-->
<!--&lt;!&ndash;                "&ndash;&gt;-->
<!--&lt;!&ndash;                    style="height: 90px;width: 200px;margin-bottom:12px;margin-left:120px"&ndash;&gt;-->
<!--&lt;!&ndash;                  />&ndash;&gt;-->
<!--&lt;!&ndash;                </div>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->

<!--            &lt;!&ndash; <ul id="article-list">-->
<!--              <li class="article-li" v-for="(item, i) in contentList" :key="i">-->
<!--                <div style="width:60%;height:100px;float:left">-->
<!--                  <div-->
<!--                    class="article-title"-->
<!--                    @click="toDetail(item.id, item.title)"-->
<!--                    :title="item.title"-->
<!--                    style="text-align: left"-->
<!--                    >{{ item.title }}</div-->
<!--                  >-->
<!--                  <div class="article-time">{{ item.addDate.substr(0, 11) }}</div>-->
<!--                </div>-->
<!--                <div  style="width:40%;height:100px;float:left">-->

<!--                </div>-->
<!--              </li>-->
<!--            </ul> &ndash;&gt;-->
<!--            <el-pagination-->
<!--              style="text-align: center;margin-top: 10px;"-->
<!--              @size-change="handleSizeChange"-->
<!--              @current-change="handleCurrentChange"-->
<!--              :current-page="page"-->
<!--              :page-sizes="[10, 40, 50, 60]"-->
<!--              :page-size="length"-->
<!--              layout="total, sizes, jumper, prev, pager, next"-->
<!--              :total="total"-->
<!--            >-->
<!--            </el-pagination>-->
<!--          </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--//引入vuex附属函数-->
<!--import { mapGetters, mapActions } from "vuex";-->
<!--import defaultImg from "@/assets/2.png"-->
<!--export default {-->
<!--  name: "list",-->
<!--  data() {-->
<!--    return {-->
<!--      fullscreenLoading: false,-->
<!--      menuId: this.$route.params.menuId,-->
<!--      firstMenuName: "",-->
<!--      firstMenuId: "",-->
<!--      menuList: [],-->
<!--      contentList: [],-->
<!--      total: 0, //总页数-->
<!--      page: 1, //页码-->
<!--      length: 10, //长度-->
<!--      linkAddress: "", //链接地址-->
<!--      defaultImg:defaultImg,-->
<!--      activeIndex:0,//默认选中样式-->
<!--    };-->
<!--  },-->
<!--  methods: {-->
<!--    toList(menuId, label) {-->
<!--      this.$router.push({-->
<!--        path: "List:menuId",-->
<!--        name: "List",-->
<!--        params: { menuId: menuId, label: label }-->
<!--      });-->
<!--    },-->
<!--    // 每页条数变化-->
<!--    handleSizeChange(val) {-->
<!--      this.length = val;-->
<!--      this.page = 1;-->
<!--      this.getSecondList();-->
<!--    },-->
<!--    // 页码变化-->
<!--    handleCurrentChange(val) {-->
<!--      this.page = val;-->
<!--      this.getSecondList();-->
<!--    },-->
<!--    getSecondList() {-->
<!--      this.fullscreenLoading = true;-->
<!--      let fd = new FormData();-->
<!--      fd.append("page", this.page);-->
<!--      fd.append("num", this.length);-->
<!--      var choosedItem = {};-->
<!--      // console.log("this.firstMenuName", this.firstMenuName);-->
<!--          axios-->
<!--            .post("/cmsapi/menus/" + this.$route.params.menuId, fd, {-->
<!--              //顶部友情链接-->
<!--              headers: { "Content-Type": "application/x-www-form-urlencoded" }-->
<!--            })-->
<!--            .then(response => {-->
<!--              var recData = response.data;-->
<!--              if (recData.secondMenu.length > 0) {-->
<!--                recData.secondMenu.forEach((item, index) => {-->
<!--                  if (item.id == this.menuId) {-->
<!--                    choosedItem = item;-->
<!--                    this.linkAddress = item.href ? item.href : "";-->
<!--                  }-->
<!--                });-->
<!--              }-->

<!--              this.total = recData.total;-->
<!--              //在result里面还有个菜单路径，用的话在这里处理-->
<!--              //self.menuList = result;-->
<!--              this.firstMenuName = recData.firstMenuName;-->
<!--              console.log("this.firstMenuName", this.firstMenuName);-->
<!--              this.firstMenuId = recData.menuId;-->
<!--              this.contentList = recData.dataList;-->
<!--              //如果没有文章，跳转到第一个二级菜单-->
<!--              /*if(this.total == 0) {-->
<!--          }*/-->
<!--              //如果只有一条就跳转,直接显示文章-->

<!--              // if(this.total == 1) {-->
<!--              //   this.$router.push({-->
<!--              //     path:'detail:contentId',-->
<!--              //     name:'Detail',-->
<!--              //     params:{contentId:this.contentList[0].id,label:this.contentList[0].title}-->
<!--              //   });-->
<!--              //-->
<!--              //   // window.location.href = "detail.html?contentId="+this.contentList[0].id;-->
<!--              // }-->

<!--              if (-->
<!--                recData.menuName == "仪器预约记录" ||-->
<!--                recData.menuName == "实验室预约记录" ||-->
<!--                choosedItem.label == "使用记录" ||-->
<!--                recData.menuName == "考勤记录" ||-->
<!--                recData.menuName == "实验室信息" ||-->
<!--                recData.menuName == "成绩查询" ||-->
<!--                recData.menuName == "违规扣分处罚信息"-->
<!--              ) {-->
<!--                this.$router.push({-->
<!--                  path: "detail:contentId",-->
<!--                  name: "Detail",-->
<!--                  params: {-->
<!--                    contentId: this.contentList[0].id,-->
<!--                    label: recData.menuName-->
<!--                  }-->
<!--                });-->
<!--              } else if (this.total == 1) {-->
<!--                this.$router.push({-->
<!--                  path: "detail:contentId",-->
<!--                  name: "Detail",-->
<!--                  params: {-->
<!--                    contentId: this.contentList[0].id,-->
<!--                    label: this.contentList[0].title-->
<!--                  }-->
<!--                });-->
<!--              }-->

<!--              //如果只有一级菜单，就把一级菜单放上。-->
<!--              if (recData.secondMenu.length == 0) {-->
<!--                this.menuList = [-->
<!--                  {-->
<!--                    label: recData.firstMenuName,-->
<!--                    id: recData.menuId-->
<!--                  }-->
<!--                ];-->
<!--              } else {-->
<!--                //多条列表-->
<!--                this.menuList = recData.secondMenu;-->
<!--                if (-->
<!--                  choosedItem.label == "仪器预约记录" ||-->
<!--                  choosedItem.label == "实验室预约记录" ||-->
<!--                  choosedItem.label == "使用记录" ||-->
<!--                  choosedItem.label == "考勤记录" ||-->
<!--                  choosedItem.label == "成绩查询" ||-->
<!--                  recData.menuName == "实验室信息" ||-->
<!--                  recData.menuName == "违规扣分处罚信息"-->
<!--                ) {-->
<!--                  this.$router.push({-->
<!--                    path: "detail:contentId",-->
<!--                    name: "Detail",-->
<!--                    params: {-->
<!--                      contentId: this.contentList[0].id,-->
<!--                      label: choosedItem.label-->
<!--                    }-->
<!--                  });-->
<!--                }-->
<!--              }-->
<!--              this.fullscreenLoading = false;-->
<!--            })-->
<!--            .catch(error => {-->
<!--              this.fullscreenLoading = false;-->
<!--            });-->


<!--    },-->
<!--    toDetail(row,index) {-->
<!--      this.activeIndex = index;-->
<!--      this.$router.push({-->
<!--        path: "detail:contentId",-->
<!--        name: "Detail",-->
<!--        params: { contentId: row.id, label: row.title }-->
<!--      });-->
<!--    }-->
<!--  },-->
<!--  computed: {-->
<!--    ...mapGetters(["isMobile"])-->
<!--},-->
<!--  mounted() {-->
<!--    this.$nextTick(() => {-->
<!--      if (this.$route.params.menuId) {-->
<!--        this.menuId = this.$route.params.menuId;-->
<!--        this.getSecondList();-->
<!--      }-->
<!--    });-->
<!--  },-->
<!--  beforeEacch(to, from, next) {-->
<!--    if (this.$route.params.menuId) {-->
<!--      this.menuId = this.$route.params.menuId;-->
<!--      this.getSecondList();-->
<!--    }-->
<!--    next();-->
<!--  },-->
<!--  beforeRouteUpdate(to, from, next) {-->
<!--    next();-->
<!--    // if (this.$route.params.menuId) {-->
<!--    this.menuId = this.$route.params.menuId;-->
<!--    this.getSecondList();-->
<!--    // }-->
<!--  }-->
<!--};-->
<!--</script>-->
<!--<style scoped lang="less">-->
<!--.contentBox{-->
<!--  width: 1100px;-->
<!--  display: flex;-->
<!--  justify-content: space-between;-->
<!--  min-height: 600px;-->
<!--  .left-nav{-->
<!--    width: 19%;-->
<!--    position: relative;-->
<!--    height: 300px;-->
<!--    background-color: #f2f2f2;-->
<!--    .bg_title{-->
<!--      width: 209px;-->
<!--      height: 90px;-->
<!--      background: url("~@/assets/list/bg1.png");-->
<!--      background-size: 100% 100%;-->
<!--      padding: 15px 0 0 25px;-->
<!--    }-->
<!--  }-->
<!--  .rightContent{-->
<!--    width: 80%;-->
<!--    .box_card{-->
<!--      display: flex;-->
<!--      justify-content: space-between;-->
<!--      width: 100%;-->
<!--      height: 100%;-->
<!--      padding: 5px;-->
<!--      .card_data{-->
<!--        width: 49%;-->
<!--        height: 100px;-->
<!--        .card_flex{-->
<!--          display: flex;-->
<!--          align-items: center;-->
<!--          justify-content: space-between;-->
<!--          .left_box{-->
<!--            width: 80%;-->
<!--            .titleTime{-->
<!--              color: #a1a1a1;-->
<!--              font-size: 12px;-->
<!--            }-->
<!--          }-->
<!--          .right_box{-->
<!--            width: 22%;-->
<!--            height: 100%;-->
<!--            img{-->
<!--            width: 100%;-->
<!--              height: 100%;-->
<!--              object-fit: cover;-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--      }-->
<!--      .active_card{-->
<!--        width: 49%;-->
<!--        height: 100px;-->
<!--        //左边框-->
<!--        border-left: #002b9e 3px solid;-->
<!--        .card_flex{-->
<!--          display: flex;-->
<!--          align-items: center;-->
<!--          justify-content: space-between;-->
<!--          .left_box{-->
<!--            width: 80%;-->
<!--            .titleTime{-->
<!--              color: #a1a1a1;-->
<!--              font-size: 12px;-->
<!--            }-->
<!--          }-->
<!--          .right_box{-->
<!--            width: 22%;-->
<!--            height: 100%;-->
<!--            img{-->
<!--              width: 100%;-->
<!--              height: 100%;-->
<!--              object-fit: cover;-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--        .title{-->
<!--          color: #002b9e;-->
<!--        }-->
<!--      }-->
<!--    }-->
<!--  }-->
<!-- /deep/ .el-card__body{-->
<!--    padding: 10px !important;-->
<!--  }-->
<!--}-->



<!--.titleNav{-->
<!--  position: absolute;-->
<!--  top: -10%;-->
<!--}-->

<!--</style>-->
<template>
  <div>
    <component :is="componentType"></component>
  </div>
</template>

<script>
export default {
  name: "Home",

  components: {
    PcDetail: () => import("./DetailPc.vue"), // PC端组件
    MobileDetail: () => import("./Mobile/DetailMobile.vue"), // 移动端组件
  },

  computed: {
    componentType() {
      return this.$store.state.isMobile ? "MobileDetail" : "PcDetail";
    },
  },
  created() {
  },
  mounted() {
    // window.scrollTo(0, 0);
    console.log(document.documentElement.scrollTop,'element高度1');
    console.log(document.body.scrollTop,'body高度1');
  }

};
</script>

<style scoped></style>
